module.exports = __webpack_public_path__ + "img/arms-on-bg7.11525a71.png";